import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";
import {use_e2ee} from "../utils/utils";

export const CurationPromptService = (program_id, user_message) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/program/curation/prompt',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id,
        user_message
    };

    return invokeApi(requestObj);
}

export const CurationPromptStreamService = (program_id, user_message) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const baseUri = process.env.REACT_APP_MYDQ_API;
    return fetch(`${baseUri}/dq_insider/dqin/learning_program/curation_prompt`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            program_id,
            user_message
        })
    });
};


export const createProgramService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/program/new',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
    };

    return invokeApi(requestObj);
}

export const fetchProgramService = (programId) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/program/fetch',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        'program_id': programId
    };

    return invokeApi(requestObj);
}

export const buildLearningProgramService = (
    code,
    full_name,
    target_audience,
    dq_codes,
    time_to_complete_minutes,
    image_url,
    theme_color,
    badge_background,
    primary_color,
    description,
    more_info,
    translations,
    program_details
) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/dqin/learning_program/build',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        code,
        full_name,
        target_audience,
        dq_codes,
        time_to_complete_minutes,
        image_url,
        theme_color,
        badge_background,
        primary_color,
        description,
        more_info,
        translations,
        program_details
    };

    return invokeApi(requestObj);
}

export const updateLearningProgramService = (code, payload) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/dq_insider/dqin/learning_program/update',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        code,
        ...payload
    };

    return invokeApi(requestObj);
}

export const getLearningProgramPreviewService = ( dq_module_code ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/preview',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { dq_module_code };
    return invokeApi(requestObj);
};

export const getLearningProgramPreviewStatusService = ( dq_module_code ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/preview/status',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { dq_module_code };
    return invokeApi(requestObj);
};

export const getLearningProgramSlidePreviewService = ( dq_module_code, session_no ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/slide_preview',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { dq_module_code, session_no };
    return invokeApi(requestObj);
};

export const getLearningProgramStatusService = ( dq_module_code ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/status',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { dq_module_code };
    return invokeApi(requestObj);
};

export const getLearningProgramDescriptionService = ( target_audience, locales, dq_codes ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/description',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { target_audience, locales, dq_codes };
    return invokeApi(requestObj);
};

export const isLearningProgramReadyService = ( dq_module_code ) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/is_ready',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    requestObj['postData'] = { dq_module_code };
    return invokeApi(requestObj);
};

export const getInsiderProgramsService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/insider_programs',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };
    
    return invokeApi(requestObj);
};

export const getInsiderProgramService = (dq_module_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/insider_program',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };

    requestObj['postData'] = { dq_module_code };
    return invokeApi(requestObj);
};

export const linkLearningProgramService = (org_code, dq_module_codes) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/client/link_learning_program',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };

    requestObj['postData'] = {
        org_code,
        dq_module_codes
    };
    return invokeApi(requestObj);
};

export const getLinkedLearningProgramService = (org_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: `/dq_insider/dqin/client/get_linked_learning_program/${org_code}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };

    return invokeApi(requestObj);
};

export const generateLearningProgramContentService = (dq_module_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/generate_content',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    };

    requestObj['postData'] = {
        dq_module_code,
    };
    return invokeApi(requestObj);
};

export const listV3Level7DQCodeService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/v3_level7_dqcode/list',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    return invokeApi(requestObj);
};

export const getActiveChatInsiderProgramService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/active_chat',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    return invokeApi(requestObj);
};

export const saveChatStateInsiderService = (program_id, state_data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/chat_state/save',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id,
        state_data
    };
    return invokeApi(requestObj);
};

export const loadChatStateInsiderService = (program_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/chat_state/load',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id
    };
    return invokeApi(requestObj);
};

export const clearChatStateInsiderService = (program_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/chat_state/clear',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id
    };
    return invokeApi(requestObj);
};

export const removeModuleFromProgramService = (program_id, module_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/remove/module',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id,
        module_id
    };
    return invokeApi(requestObj);
};

export const removeUnitFromModuleService = (program_id, module_id, unit_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/remove/unit',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id,
        module_id,
        unit_id
    };
    return invokeApi(requestObj);
};

export const removeSessionFromUnitService = (program_id, module_id, unit_id, session_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dq_insider/dqin/learning_program/remove/session',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        program_id,
        module_id,
        unit_id,
        session_id
    };
    return invokeApi(requestObj);
};